import React from "react"

import Layout from "components/layout"
import SEO from "components/seo"

import Hero from "sections/home/hero"
import WhatIs from "sections/home/whatIs"
import Products from "sections/products"
import Clients from "sections/clients"
import Mission from "sections/home/mission"
import FinancialWellbeign from "sections/home/financialWellbeign"
import Results from "sections/results"
import Testimonials from "sections/testimonials"
import Numbers from "sections/numbers"
import CTA from "sections/cta"

const IndexPage = () => {
  return (
    <Layout dark>
      <SEO title="" />
      <article>
        <Hero />
        <WhatIs />
        <Products />
        <Mission />
        <FinancialWellbeign />
        <Results />
        <Clients />
        <Testimonials />
        <Numbers />
        <CTA />
      </article>
    </Layout>
  )
}

export default IndexPage
